function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33.8 52.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.39,1.01C4.73,3.59,2.89,6.15,2.89,10.08c0,2.14.51,4.85,1.14,6.03,3.16,5.9,3.65,11.15,1.74,18.66-1.01,4-2.75,8.74-3.86,10.54-3.7,5.99-1.82,9.03,3.79,6.13,2.66-1.38,3.06-1.38,3.57-.04.52,1.35.9,1.35,3.49,0,3.39-1.75,8.53-7.96,9.59-11.57.4-1.38,3.16-7.97,6.13-14.65,6.42-14.43,6.8-18,2.32-21.76-3.47-2.92-3.76-2.98-7.45-1.58-1.96.74-3.83.61-7.1-.5-5.19-1.76-4.38-1.72-6.88-.34",
    style: {
      fill: "#010101",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.46,3.94c.44.72,2.53.87,5.99.44,4.57-.57,5.61-.37,7.38,1.4,2.74,2.74,2.61,4.4-.89,11.81l-2.96,6.25H9.39l-2.25-6.44c-2.81-8.05-2.8-8.68.2-11.92,2.56-2.76,7.81-3.65,9.11-1.55",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.37,27.82c-4.01,10.97-6.49,15.96-9.32,18.79-1.85,1.85-3.57,3.15-3.83,2.89-.26-.26.74-3.86,2.21-8,3.19-8.98,2.84-12.55-.4-4.07-2.29,5.99-7.41,12.4-9.91,12.4-1,0-.79-.81.74-2.97,1.16-1.63,3.09-6.92,4.28-11.75l2.17-8.78,7.3-.02c6.11-.02,7.21.23,6.75,1.5",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg48);
export default __webpack_public_path__ + "static/media/48.b8d2c4df88b1e459938f485b3f36c889.svg";
export { ForwardRef as ReactComponent };